import ajax from "@/lib/ajax";

export async function batch_translate(query = {}) {
    return await ajax.post("xiaoyue-operation/helper/batch/translate", { ...query });
}